import { render, staticRenderFns } from "./target-table.vue?vue&type=template&id=326acce6&scoped=true&"
import script from "./target-table.vue?vue&type=script&lang=js&"
export * from "./target-table.vue?vue&type=script&lang=js&"
import style0 from "./target-table.vue?vue&type=style&index=0&id=326acce6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326acce6",
  null
  
)

export default component.exports